/**
 * App Shell
 * Main layout wrapper for the application
 */

import React from 'react';

interface AppShellProps {
  children: React.ReactNode;
}

/**
 * AppShell - Main layout wrapper
 * Extracted from App.tsx to separate layout concerns
 */
export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      {children}
    </div>
  );
};
